module.exports = __webpack_public_path__ + "img/23.e7085485.png";